import axios from 'axios'
import { Dispatch, SetStateAction } from 'react'
import 'regenerator-runtime/runtime'

class Postier {
    getHoraires(token:string,client:string,site:string,setHoraires,date:string, setErrors: Dispatch<SetStateAction<string[]>>){
        const chemin = `/api-v0/horaires/${client.split(":")[3]}/${site.split(':')[0]}`

        axios.post(chemin,{date},{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                let data = res.data
                const first = data.shift()
                data.push(first)
                setHoraires(data)
        }).catch(err=>{
            setHoraires([])
            setErrors((errors: string[]) => [...errors, "Les horaires ne peuvent pas être récupérées"])
            localStorage.clear()
            // location.reload()
        })

    }

    createHoraire(token:string,client:string,site:string,setHoraires,date:string, setErrors: Dispatch<SetStateAction<string[]>>){
        const api = localStorage.getItem("apiId")
        const chemin = `/api-v0/horaires/create/${api}/${client.split(":")[3]}/${site.split(':')[0]}`
        axios.get(chemin,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                let data = res.data
                const first = data.shift()
                data.push(first)
                setHoraires(data)
        }).catch(err=>{
            setHoraires([])
            setErrors((errors: string[]) => [...errors, "L'horaire ne peut pas être crée"])
        })

    }

    updateHoraire(token:string,client:string,site:string,setLoading,setPage,horaires, setErrors: Dispatch<SetStateAction<string[]>>){

        const api = localStorage.getItem("apiId")

        const chemin = `/api-v0/horaires/update/${api}/${client.split(":")[3]}/${site.split(':')[0]}`

        axios.post(chemin,horaires,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setPage("main")
                setLoading(false)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "L'horaire ne peut pas être modifiée"])
            setLoading(false)

        })

    }


}

export const postier = new Postier()